import React, { useEffect, useRef, useState } from 'react'
import { IconButton, InputBase, Paper, Theme } from '@mui/material'
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined'
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined'
import makeStyles from '@mui/styles/makeStyles'
import createStyles from '@mui/styles/createStyles'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    input: {
      fontSize: '0.9em',
    },
  })
)

interface Props {
  defaultValue: string
  onEdit: (value: string) => void
  onCancel?: () => void
  className?: any
}

export const InlineEdit: React.FC<Props> = ({ defaultValue, onEdit, className, onCancel }) => {
  const classes = useStyles()
  const [value, setValue] = useState(defaultValue)
  const handleKey = (event: any) => {
    if ((event.code === 'Enter' || event.code === 'NumpadEnter') && !event.shiftKey) {
      onEdit(value)
    }
  }
  const ref = useRef<any>(null)
  useEffect(() => {
    ref?.current?.focus()
  }, [])

  return (
    <Paper
      className={className}
      sx={{ p: '0px 4px', display: 'flex', alignItems: 'center', width: 100 }}
    >
      <InputBase
        inputRef={ref}
        className={classes.input}
        onChange={e => setValue(e.target.value)}
        onKeyDown={handleKey}
        size="small"
        value={value}
        sx={{ ml: 1, flex: 1 }}
        onFocus={e => e.target.select()}
      />
      <IconButton size="small" sx={{ p: '8px' }} aria-label="search" onClick={e => onEdit(value)}>
        <CheckOutlinedIcon sx={{ height: 12, width: 12 }} />
      </IconButton>
      {onCancel && (
        <IconButton size="small" sx={{ p: '8px' }} aria-label="search" onClick={e => onCancel()}>
          <ClearOutlinedIcon sx={{ height: 12, width: 12 }} />
        </IconButton>
      )}
    </Paper>
  )
}
